import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@dev-go4ellis/go4-design-system';
import './Header.scss';

const NAV_ITEMS = [
  { label: 'Pricing', href: '#pricing' },
  { label: 'How it works', href: '#how' },
  { label: 'Coverage & compliance', href: '#trust' },
  { label: 'FAQ', href: '#faq' },
];

const Header = ({ onLogin, onPostJob }) => (
  <header className="pl-header">
    <div className="pl-header__left">
      <div className="pl-header__logo">Go<span>4</span></div>
      <nav className="pl-header__nav">
        {NAV_ITEMS.map((item) => (
          <a key={item.href} href={item.href} className="pl-header__link">{item.label}</a>
        ))}
      </nav>
    </div>
    <div className="pl-header__actions">
      <button type="button" className="pl-header__login" onClick={onLogin}>Log in</button>
      <Button variant="primary" size="md" onClick={onPostJob}>Post a job</Button>
    </div>
  </header>
);

Header.propTypes = {
  onLogin: PropTypes.func,
  onPostJob: PropTypes.func,
};

Header.defaultProps = {
  onLogin: () => {},
  onPostJob: () => {},
};

export default Header;
